import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { LEASE_VIEW_TYPES } from '../models/Lease';
import { trackError } from '../utils/trackError';
import ColandlordSelfServeView from './ColandlordLeaseView/ColandlordSelfServeView';
import ColandlordLeaseSummary from './ColandlordLeaseView/ColandlordLeaseSummary';
import { useLeasingUrlParams } from '../hooks/useLeasingUrlParams';
import { useLeaseFromOuidQuery } from '../utils/queries';

function ColandlordLeaseView() {
  const history = useHistory();
  const { nestedViewType } = useLeasingUrlParams();

  const queryParams = new URLSearchParams(window.location.search);
  const ouid = queryParams.get('ouid');

  const leaseQuery = useLeaseFromOuidQuery(ouid, !!ouid);
  const lease = leaseQuery.data;

  useEffect(() => {
    if (!lease) {
      return;
    }

    lease.forceRedirectIfWrongViewType(history, nestedViewType as LEASE_VIEW_TYPES, trackError);
  }, [lease, history, nestedViewType]);

  return nestedViewType === LEASE_VIEW_TYPES.SELF_SERVE ? <ColandlordSelfServeView /> : <ColandlordLeaseSummary />;
}

export default ColandlordLeaseView;
